// extracted by mini-css-extract-plugin
export default {"rendeles":"Rendeles_rendeles__bfqso","content":"Rendeles_content__T6tQL","image":"Rendeles_image__oydGv","button":"Rendeles_button__J6UFP"};